import { SupportCategories } from '@/shared/enums/SupportCategories';

export const SupportCategoriesIcons = {
	[SupportCategories.REQUEST_1_NEW_SERVICE]: 'icon-checkmarks-sheet',
	[SupportCategories.REQUEST_2_EXTENDING_SERVICE]: 'icon-update',
	[SupportCategories.REQUEST_3_CHANGE_PACKAGE]: 'icon-dots-sheet',
	[SupportCategories.COMPLAINT_1_QUALITY]: 'icon-rounded-exclamation',
	[SupportCategories.COMPLAINT_2_EQUIPMENT]: 'icon-fix-tel',
	[SupportCategories.COMPLAINT_3_CONTRACT]: 'icon-checkmarks-sheet',
	[SupportCategories.COMPLAINT_4_BILL]: 'icon-dots-sheet'
};
